import { type ActionType } from "~/app/store/types";
import { type SaPageState, SaTabs } from "~/features/selectionAssistant/bearing/redux/types";
import { CHANGE_SA_TAB } from "~/features/selectionAssistant/bearing/redux/actions";

export const initialState: SaPageState = {
  activeTab: SaTabs.CHARACTERISTICS,
};

export const saReducer = (state = initialState, action: ActionType<{}>): SaPageState => {
  switch (action.type) {
    case CHANGE_SA_TAB: {
      const tab = action.payload as SaTabs;

      return {
        ...state,
        activeTab: tab,
      };
    }
    default:
      return state;
  }
};
